import React, { useState } from "react";
import { MdVerified, MdScience, MdBuild, MdStar } from "react-icons/md";
import { ChangeLogsTile } from "./ChangeLogsTile";
import { TabsContainer, TabsHeader, TabItem, TabContent } from "./styled";

const FAVORITE_CHANGELOGS_KEY = "favoriteChangelogsIds";

export const ChangesLog = ({ data }) => {
  const [activeTab, setActiveTab] = useState("DEV");
  const [favoriteKeys, setFavoriteKeys] = useState(() => {
    if (typeof window === "undefined") {
      return [];
    }

    const savedFavorites = localStorage.getItem(FAVORITE_CHANGELOGS_KEY);

    if (!savedFavorites) {
      return [];
    }

    try {
      const parsedFavorites = JSON.parse(savedFavorites);
      return Array.isArray(parsedFavorites) ? parsedFavorites : [];
    } catch {
      return [];
    }
  });

  const changeLogs = data?.changelogs || [];

  const getChangeLogKey = (item) => {
    if (item?.id !== undefined && item?.id !== null && item?.id !== "") {
      return `id:${item.id}`;
    }

    if (item?.link) {
      return `link:${item.link}`;
    }

    return `fallback:${item?.repoName || ""}|${item?.description || ""}|${item?.pamBuildVersion || ""}|${item?.pamBuildVersionBeta || ""}|${item?.pamBuildVersionDev || ""}`;
  };

  const sortByVersionDesc = (list, versionKey) =>
    list.sort((a, b) => {
      const parseVersion = (version) => {
        if (!version) return [0, 0, 0];
        const parts = version.split(".").map((part) => parseInt(part, 10) || 0);
        return [parts[0] || 0, parts[1] || 0, parts[2] || 0];
      };

      const [majorA, minorA, patchA] = parseVersion(a[versionKey]);
      const [majorB, minorB, patchB] = parseVersion(b[versionKey]);

      if (majorA !== majorB) return majorB - majorA;
      if (minorA !== minorB) return minorB - minorA;
      return patchB - patchA;
    });

  const prodChangeLogs = sortByVersionDesc(
    changeLogs.filter((item) => item.pamBuildVersion),
    "pamBuildVersion"
  );
  const betaChangeLogs = sortByVersionDesc(
    changeLogs.filter((item) => item.pamBuildVersionBeta),
    "pamBuildVersionBeta"
  );
  const devChangeLogs = sortByVersionDesc(
    changeLogs.filter((item) => item.pamBuildVersionDev),
    "pamBuildVersionDev"
  );
  const favoriteChangeLogs = changeLogs.filter((item) => favoriteKeys.includes(getChangeLogKey(item)));

  const toggleFavorite = (changeLogKey) => {
    setFavoriteKeys((previousFavorites) => {
      const isFavorite = previousFavorites.includes(changeLogKey);
      const nextFavorites = isFavorite
        ? previousFavorites.filter((favoriteKey) => favoriteKey !== changeLogKey)
        : [...previousFavorites, changeLogKey];

      if (typeof window !== "undefined") {
        localStorage.setItem(FAVORITE_CHANGELOGS_KEY, JSON.stringify(nextFavorites));
      }

      return nextFavorites;
    });
  };

  const renderContent = () => {
    switch (activeTab) {
      case "DEV":
        return (
          <ChangeLogsTile
            list={devChangeLogs}
            tileHeader="Lista Zmian - wersja DEV"
            versionType="pamBuildVersionDev"
            favoriteKeys={favoriteKeys}
            onToggleFavorite={toggleFavorite}
            getItemKey={getChangeLogKey}
          />
        );
      case "BETA":
        return (
          <ChangeLogsTile
            list={betaChangeLogs}
            tileHeader="Lista Zmian - wersja BETA"
            versionType="pamBuildVersionBeta"
            favoriteKeys={favoriteKeys}
            onToggleFavorite={toggleFavorite}
            getItemKey={getChangeLogKey}
          />
        );
      case "PROD":
        return (
          <ChangeLogsTile
            list={prodChangeLogs}
            tileHeader="Lista Zmian - wersja PROD"
            versionType="pamBuildVersion"
            favoriteKeys={favoriteKeys}
            onToggleFavorite={toggleFavorite}
            getItemKey={getChangeLogKey}
          />
        );
      case "OBSERWOWANE":
        return (
          <ChangeLogsTile
            list={favoriteChangeLogs}
            tileHeader="Lista obserwowanych zmian"
            versionType="currentVersion"
            favoriteKeys={favoriteKeys}
            onToggleFavorite={toggleFavorite}
            getItemKey={getChangeLogKey}
          />
        );
      default:
        return null;
    }
  };

  if (changeLogs.length === 0) {
    return null;
  }

  return (
    <TabsContainer>
      <TabsHeader>
        <TabItem $active={activeTab === "DEV"} onClick={() => setActiveTab("DEV")}>
          <MdBuild /> DEV
        </TabItem>
        <TabItem $active={activeTab === "BETA"} onClick={() => setActiveTab("BETA")}>
          <MdScience /> BETA
        </TabItem>
        <TabItem $active={activeTab === "PROD"} onClick={() => setActiveTab("PROD")}>
          <MdVerified /> PROD
        </TabItem>
        <TabItem $active={activeTab === "OBSERWOWANE"} onClick={() => setActiveTab("OBSERWOWANE")}>
          <MdStar /> OBSERWOWANE
        </TabItem>
      </TabsHeader>
      <TabContent>{renderContent()}</TabContent>
    </TabsContainer>
  );
};
